<template>
  <span v-if="label" class="legacy-entry-tag" :title="'Tipo de entrada: ' + label" :aria-label="'Tipo de entrada: ' + label">{{ label }}</span>
</template>

<script>
export default {
  props: { value: { type: String, default: '' } },
  computed: {
    label() {
      const text = (this.value || '').trim();
      return text && !/^-+$/.test(text) ? text : '';
    }
  }
};
</script>

<style scoped>
.legacy-entry-tag {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  margin: 0 6px;
  padding: 1px 4px;
  border: 1px solid currentColor;
  border-radius: 3px;
  font-size: 9px;
  line-height: 14px;
  font-weight: 500;
  white-space: nowrap;
  opacity: .75;
}
</style>
